// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import theme from './theme';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import i18n from './i18n';
import { UserProvider } from './contexts/UserContext';
import { IdleTimerProvider } from './contexts/IdleTimerContext';
import { Analytics } from '@vercel/analytics/react';
import { LicenseInfo } from '@mui/x-license'; 

// MUI license key
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY);

const direction = 'rtl';

// Optionally load Hebrew locale if you're using MUI's built-in heIL translations
const themeWithDirection = createTheme(
  {
    ...theme,
    direction: direction,
  },
  i18n.language === 'he' ? require('@mui/material/locale').heIL : {}
);

document.body.dir = direction;

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={themeWithDirection}>
          <CssBaseline />
          <BrowserRouter>
            <UserProvider>
              <IdleTimerProvider>
                <App />
                <Analytics /> {/* Analytics component here */}
              </IdleTimerProvider>
            </UserProvider>
          </BrowserRouter>
        </ThemeProvider>
      </StyledEngineProvider>
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// ===== ADD THIS CODE BELOW =====
// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('✅ Service Worker registered:', registration);
      })
      .catch(error => {
        console.log('❌ Service Worker registration failed:', error);
      });
  });
}